module.exports = __webpack_public_path__ + "static/media/banner_directoriogeneral_noestassola_imgn_3.4d18b636.jpg";